export default "__VITE_ASSET__BLJRzR9H__"